import { useCallback } from 'react';

import { OrderSide, type OrderSide as OrderSideType } from '@ping/api';
import { Store } from '@ping/utils';

interface ISelectedOrderSideSignal {
  value: Lowercase<OrderSideType>;
}

// --------------------------------------------------------------------------------
// SELECTED ORDER SIDE SIGNAL
// --------------------------------------------------------------------------------
const selectedOrderSideSignal = new Store<ISelectedOrderSideSignal>({ value: OrderSide.Buy.toLowerCase() })
  .withDevTools()
  .build();

// --------------------------------------------------------------------------------
// SELECTED ORDER SIDE HOOK
// --------------------------------------------------------------------------------
export const useSelectedOrderSideSignal = () => {
  const value = selectedOrderSideSignal(state => state.value);
  const set = useCallback((input: Lowercase<OrderSideType>) => selectedOrderSideSignal.setState({ value: input }), []);

  return Object.freeze({ value, set });
};

// --------------------------------------------------------------------------------
// SELECTED ORDER SIDE NON-REACT
// --------------------------------------------------------------------------------
useSelectedOrderSideSignal.get = () => selectedOrderSideSignal.getState().value;
useSelectedOrderSideSignal.set = (input: Lowercase<OrderSideType>) =>
  selectedOrderSideSignal.setState({ value: input });
